import { decodeJwt } from "jose"
import { z } from "zod"

export const ZeroJwtPayloadSchema = z.object({
	sub: z.string().min(1),
	workspaceId: z.string().min(1),
	role: z.enum(["ADMIN", "USER", "VIEWER"]),
	globalRole: z.enum(["ADMIN", "USER"]),
	userId: z.string().min(1),
	readOnly: z.boolean().optional(),
})
export type ZeroJwtPayload = z.infer<typeof ZeroJwtPayloadSchema>

export function decodeZeroJwt(token: string) {
	const decoded = decodeJwt(token)
	const parsed = ZeroJwtPayloadSchema.safeParse(decoded)
	return parsed
}
